import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPublicTransport = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 30,
	viewBox: "0 0 30 30",
	width: 30,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m1590.444 262.46.741-.583a.45.45 0 0 1 .235-.067h4.414a.45.45 0 0 1 .233.067l.741.583",
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 22.926,
			transform: "translate(-1578.791 -256.81)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m14.835 5v2.67",
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 22.926
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1603.263 292.189a.907.907 0 1 1 -.908.908.908.908 0 0 1 .908-.908z",
			fill: "currentColor",
			fillRule: "evenodd",
			transform: "translate(-1585.154 -273.116)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1589.838 292.189a.907.907 0 1 1 -.907.908.907.907 0 0 1 .907-.908z",
			fill: "currentColor",
			fillRule: "evenodd",
			transform: "translate(-1578.276 -273.116)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m1585.028 273.656c0-.313.342-.543.75-.569a81.863 81.863 0 0 1 10.115 0c.41.022.75.257.75.569",
					stroke: "currentColor",
					strokeMiterlimit: 22.926,
					transform: "translate(-1576 -262.766)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m1596.643 286.718c0 1.136-11.615 1.141-11.615 0",
					stroke: "currentColor",
					strokeMiterlimit: 22.926,
					transform: "translate(-1576 -270.154)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m1587.418 267.3h6.836a2.38 2.38 0 0 1 2.389 2.357v11.161a1.59 1.59 0 0 1 -1.39 1.293 43.824 43.824 0 0 1 -8.832 0 1.591 1.591 0 0 1 -1.392-1.3v-11.157a2.381 2.381 0 0 1 2.389-2.357z",
					stroke: "currentColor",
					strokeMiterlimit: 22.926,
					transform: "translate(-1576.001 -259.637)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m10.548 25h8.575",
					stroke: "currentColor",
					strokeMiterlimit: 22.926
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 15,
					cy: 15,
					r: 15
				})
			]
		})
	]
});
export default SvgPublicTransport;
